/* eslint-disable */
// import libs
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
// import css
import styles from './DrawerPanel.css';

// ========== ========== ========== ========== ========== ========== ========== ==========
// Sidebar width in css - reference
// @value sidebarWidth 220px;
// @value sidebarCollapsedWidth 60px;
// ========== ========== ========== ========== ========== ========== ========== ==========

const DrawerPanel = props => {
  const {
    anchor,
    anchorToSidebar,
    active,
    childComponent,
    handleDrawerClose,
    windowStyle,
    banner = false,
    bannerText = '',
    bannerTopMargin = 0,
  } = props;
  const dispatch = useDispatch();
  const { sidebarIsCollapsed } = useSelector(state => state.app);
  const leftAnchorWidth = anchorToSidebar ? (sidebarIsCollapsed ? 60 : 220) : 0;
  const bannerPosition = sidebarIsCollapsed ? {
    left: `${windowStyle.width + 59}px`, // sidebarIsCollapsed -60 width -1 to overlap 
    top: `${bannerTopMargin}px`
  } : {
    left: `${windowStyle.width + 219}px`, // sidebarIsCollapsed -220 width -1 to overlap 
    top: `${bannerTopMargin}px`
  }

  // overwrite style the component 
  const useStyles = makeStyles({
    paperAnchorLeft: {
      left: leftAnchorWidth,
    },
    paper: {
      overflow: 'unset',
      ...windowStyle
    }
  });
  const classes = useStyles();

  return <React.Fragment key="drawer">
    <Drawer classes={{ ...classes }} anchor={anchor} open={active}
      transitionDuration={1500}
      onClose={handleDrawerClose}>
      <div>
        {/* Child Container / Components */}
        {childComponent}
      </div>
      {banner && bannerText !== '' && bannerText !== undefined && bannerText !== null &&
        <div className={styles.banner}
          style={bannerPosition}
          onClick={handleDrawerClose}>
          <strong>{bannerText}</strong>
        </div>
      }
    </Drawer>
  </React.Fragment >
};

export default DrawerPanel;



// WEBPACK FOOTER //
// ./src/views/components/Common/DrawerPanel/DrawerPanel.jsx